import { render } from "./CartModal.vue?vue&type=template&id=8224b9ce&scoped=true"
import script from "./CartModal.vue?vue&type=script&lang=js"
export * from "./CartModal.vue?vue&type=script&lang=js"

import "./CartModal.vue?vue&type=style&index=0&id=8224b9ce&scoped=true&lang=scss"

import exportComponent from "C:\\projects\\balkan-app-links\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8224b9ce"]])

export default __exports__